<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Work Management" title="Work Details" />
         
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            
                            <div class="row mb-3" v-if="job.job_id">
                                <div class="col-6">
                                    <!-- Only show update button if job is not completed and paid -->
                                    <button 
                                        v-if="!isDealerRole && (job.job_status == 3 && job.payment_status != 1)" 
                                        class="btn btn-info" 
                                        @click="updateStatus()"
                                    >
                                        Update Payment
                                    </button>
                                    <!-- <button
                                        v-else-if="!(job.payment_status == 1 && job.job_status == 3)" 
                                        class="btn btn-primary" 
                                        @click="showCompletionModal"
                                    >
                                        Mark As Completed
                                    </button> -->
                                    <router-link
                                        v-else-if="showMarkAsCompletedLink"
                                        :to="{ name: 'mark_complete', query: { id: job_id } }"
                                        class="btn btn-primary"
                                    >Mark As Completed</router-link>
                                    <div v-else-if="showWorkCompletedPaidAlert" class="alert alert-success py-2">
                                        <i class="bx bx-check-circle me-2"></i>
                                        <strong>Work Completed & Payment Received</strong>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <button class="btn btn-warning"  @click="showCompletionModal" v-if="job.job_status != 3">
                                        Complete Data
                                    </button>
                                </div>

                                <div class="col-2">
                                    <a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>

                                </div>
                            </div>

                            <div class="row">

                                <div class="col-12">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Job Details
                                        </h4>

                                        <div class="table table-responsive">
                                            <table class="details-table table-nowrap mb-0">
                                                <tbody>

                                                    <tr width="50%">
                                                        <th scope="row">Customer Name</th>
                                                        <th>:</th>
                                                        <td>{{ job.customer_name }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Contact</th>
                                                        <th>:</th>
                                                        <td>+91 {{ job.mobile }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Location</th>
                                                        <th>:</th>
                                                        <td>{{ job.location }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Vehcile Number</th>
                                                        <th>:</th>
                                                        <td>{{ job.vehicle_no }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Product</th>
                                                        <th>:</th>
                                                        <td>{{ job.product_name }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Work Type</th>
                                                        <th>:</th>
                                                        <td>
                                                            <span v-if="job.service_type == 1">New</span>
                                                            <span v-else-if="job.service_type == 2">Repair</span>
                                                            <span v-else>Replacement</span>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Date</th>
                                                        <th>:</th>
                                                        <td>{{ proxy.$filters.convertDate(job.date) }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Work Status</th>
                                                        <th>:</th>
                                                        <td>
                                                            <span class="badge rounded-pill bg-warning" v-if="job.job_status == 1">Pending</span>
                                                            <span class="badge rounded-pill bg-info" v-else-if="job.job_status == 2">Ongoing</span>
                                                            <span class="badge rounded-pill bg-success" v-else-if="job.job_status == 3">Completed</span>
                                                            <span class="badge rounded-pill bg-primary" v-else-if="job.job_status == 4">Requested</span>
                                                            <span class="badge rounded-pill bg-danger" v-else-if="job.job_status == 5">Cancelled</span>
                                                            <span class="badge rounded-pill bg-light" v-else-if="job.job_status == 6">Reassigned</span>
                                                        </td>
                                                    </tr>

                                                    <tr v-if="job.product_id == 1">
                                                        <th scope="row">Device IMEI</th>
                                                        <th>:</th>
                                                        <td>{{ job.imei }}</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Technician</th>
                                                        <th>:</th>
                                                        <td v-if="job.technician_id">{{ job.technician_name }}</td>
                                                        <td v-else>N/A</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Engine Number</th>
                                                        <th>:</th>
                                                        <td v-if="job.engine_no">{{ job.engine_no }}</td>
                                                        <td v-else>N/A</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Chassis Number</th>
                                                        <th>:</th>
                                                        <td v-if="job.chassis_no">{{ job.chassis_no }}</td>
                                                        <td v-else>N/A</td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Work Duration</th>
                                                        <th>:</th>
                                                        <td>{{ job.work_duration_formatted }}</td>
                                                    </tr>

                                                    <tr v-if="!isDealerRole">
                                                        <th scope="row">Total Amount</th>
                                                        <th>:</th>
                                                        <td>Rs.{{ job.total_amount }}</td>
                                                    </tr>

                                                    <tr v-if="!isDealerRole">
                                                        <th scope="row">Payment Type</th>
                                                        <th>:</th>
                                                        <td>
                                                            <span v-if="job.payment_type == 1">Cash</span>
                                                            <span v-else-if="job.payment_type == 2">Online</span>
                                                            <span v-else-if="job.payment_type == 3">Both</span>                                                            
                                                        </td>
                                                    </tr>

                                                    <tr v-if="!isDealerRole">
                                                        <th scope="row">Payment Id</th>
                                                        <th>:</th>
                                                        <td>{{ job.payment_id }}</td>
                                                    </tr>

                                                    <tr v-if="!isDealerRole">
                                                        <th scope="row">Payment Status</th>
                                                        <th>:</th>
                                                        <td>
                                                            <span class="badge rounded-pill bg-success" v-if="job.payment_status === 1">Completed</span>
                                                            <span class="badge rounded-pill bg-warning" v-else-if="job.payment_status === 2 || job.payment_status === null">Pending</span>
                                                            <span class="badge rounded-pill bg-primary" v-else-if="job.payment_status === 3">Partially Paid</span>
                                                        </td>
                                                    </tr>

                                                    <tr v-if="job.product_id == 2">
                                                        <th scope="row">Camera Name</th>
                                                        <th>:</th>
                                                        <td>{{ [job.camera_name, job.camera_2, job.camera_3, job.camera_4, job.camera_5].filter(Boolean).join(', ') }}</td>
                                                    </tr>

                                                    <tr v-if="job.payment_type == 1">
                                                        <th scope="row">Amount Received</th>
                                                        <th>:</th>
                                                        <td>Rs.{{ (parseFloat(job.cash_in_hand || 0) + parseFloat(job.cash_online || 0)).toFixed(2) }}</td>
                                                    </tr>
                                                    <tr v-if="job.payment_type == 2">
                                                        <th scope="row">Amount Received</th>
                                                        <th>:</th>
                                                        <td>Rs.{{ (parseFloat(job.cash_in_hand || 0) + parseFloat(job.cash_online || 0)).toFixed(2) }}</td>
                                                    </tr>
                                                    <tr v-if="job.payment_type == 3">
                                                        <th scope="row">Amount Received</th>
                                                        <th>:</th>
                                                        <td>
                                                            <span>Total: Rs.{{ (parseFloat(job.cash_in_hand || 0) + parseFloat(job.cash_online || 0)).toFixed(2) }}</span><br>
                                                            <span>Cash: Rs.{{ job.cash_in_hand }}</span><br>
                                                            <span>Online: Rs.{{ job.cash_online }}</span>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Device Image</th>
                                                        <th>:</th>
                                                        <td><img v-if="job.images?.device_image" :src="imageUrl + job.images.device_image"  class="avatar-sm" width="70" height="70" alt="Device Image"></td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">RC Image</th>
                                                        <th>:</th>
                                                        <td><img v-if="job.images?.rc_image" :src="imageUrl + job.images.rc_image"  class="avatar-sm" width="70" height="70" alt="RC Image"></td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Vehicle Image</th>
                                                        <th>:</th>
                                                        <td><img v-if="job.images?.vehicle_image" :src="imageUrl + job.images.vehicle_image"  class="avatar-sm" width="70" height="70" alt="Vehicle Image"></td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Captured Image</th>
                                                        <th>:</th>
                                                        <td><img v-if="job.images?.captured_image" :src="imageUrl + job.images.captured_image"  class="avatar-sm" width="70" height="70" alt="Captured Image"></td>
                                                    </tr>

                                                    <tr>
                                                        <th scope="row">Created User</th>
                                                        <th>:</th>
                                                        <td>{{ job.added_user_name }}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 mt-3">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Technician Detail</h4>

                                        <div class="table-responsive product-table">
                                            <table class="display" id="basic-1">
                                                <thead>
                                                    <tr>
                                                        <th>Technician ID</th>
                                                        <th>Name</th>
                                                        <th>Conatct</th>
                                                        <th>Work Start Time</th>
                                                        <th>Work End Time</th>
                                                        <th>Earnings</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            #{{ job.technician_id }}
                                                        </td>
                                                        <td>{{ job.technician_name }}</td>
                                                        <td>{{ job.country_code + " " + job.technician_mobile }}</td>
                                                        <td>
                                                            <span v-if="job.start_time">{{ proxy.$filters.convertTime(job.start_time) }}</span>
                                                        </td>
                                                        <td>
                                                        <span v-if="job.end_time">{{ proxy.$filters.convertTime(job.end_time) }}</span>
                                                        </td>
                                                        <td>Rs.{{ job.earning }}</td>
                                                    </tr>
                                                </tbody>
                                                
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="submitPayment" enctype="multipart/form-data">
					<div class="row">
                        <template v-if="!isDealerRole">
                        <!-- Show existing payment info if available -->
                        <div class="col-md-12 mb-3" v-if="job.payment_type && (job.cash_in_hand || job.cash_online || job.payment_id)">
                            <div class="alert alert-info">
                                <i class="bx bx-info-circle me-2"></i>
                                <strong>Existing Payment Data Found:</strong> 
                                <span v-if="job.payment_type == 1">Cash: Rs.{{ job.cash_in_hand || 0 }}</span>
                                <span v-else-if="job.payment_type == 2">Online: Rs.{{ job.cash_online || 0 }} (ID: {{ job.payment_id || 'N/A' }})</span>
                                <!-- <span v-else-if="job.payment_type == 3">Cash: Rs.{{ job.cash_in_hand || 0 }} + Online: Rs.{{ job.cash_online || 0 }} (ID: {{ job.payment_id || 'N/A' }})</span> -->
                                <span v-else-if="job.payment_type == 3">Cash: Rs.{{ job.cash_in_hand || 0 }} + Online: Rs.{{ job.cash_online || 0 }} = Rs.{{ (parseFloat(job.cash_in_hand || 0) + parseFloat(job.cash_online || 0)).toFixed(2) }} (ID: {{ job.payment_id || 'N/A' }})</span>
                            </div>
                        </div>
                        
                        <div class="col-md-12 form-group">
                            <label class="control-label">Payment Type<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="payment_type" @change="onPaymentTypeChange">
								<option value="">--Select--</option>
								<option value="1">Cash</option>
								<option value="2">Online</option>
                                <option value="3">Both (Cash + Online)</option>
							</select>
                        </div>

                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Total Amount<span class="text-danger">*</span></label>
                        	<input class="form-control" type="number" v-model="total_amount" placeholder="Enter total amount" min="0" step="0.01" />
                            <small class="text-muted">Original job amount: Rs. {{ job.total_amount || 0 }}</small>
                            <div v-if="total_amount && Math.abs(parseFloat(total_amount) - parseFloat(job.total_amount || 0)) > 0.01" class="alert alert-warning mt-2 py-2">
                                <i class="bx bx-info-circle me-2"></i>
                                <strong>Note:</strong> Amount differs from original job amount by Rs. {{ (parseFloat(total_amount) - parseFloat(job.total_amount || 0)).toFixed(2) }}
                            </div>
                        </div>

                        <!-- Cash Payment Info (Payment Type 1) -->
                        <div class="col-md-12 form-group mt-3" v-if="payment_type == 1">
                            <div class="alert alert-success">
                                <i class="bx bx-check-circle me-2"></i>
                                <strong>Cash Payment Selected</strong>
                            </div>
                        </div>
                        
                        <div class="col-md-12 form-group mt-2" v-if="payment_type == 1">
                            <label class="control-label">Received Amount<span class="text-danger">*</span></label>
                            <input 
                                class="form-control" 
                                type="number" 
                                v-model="cash_amount" 
                                placeholder="Enter received amount" 
                                min="0" 
                                step="0.01" 
                                required
                            />
                            <small class="text-muted">Total amount to receive: Rs. {{ total_amount || 0 }}</small>
                            <div v-if="cash_amount && Math.abs(parseFloat(cash_amount) - parseFloat(total_amount || 0)) > 0.01" class="alert alert-warning mt-2 py-2">
                                <i class="bx bx-info-circle me-2"></i>
                                <strong>Note:</strong> Received amount differs from total amount by Rs. {{ (parseFloat(cash_amount) - parseFloat(total_amount || 0)).toFixed(2) }}
                            </div>
                        </div>

                        <!-- Online Payment Fields (Payment Type 2) -->
                        <div class="col-md-12 form-group mt-3" v-if="payment_type == 2">
                            <div class="alert alert-info">
                                <i class="bx bx-info-circle me-2"></i>
                                <strong>Online Payment Details</strong>
                            </div>
                        </div>
                        
                        <div class="col-md-12 form-group mt-2" v-if="payment_type == 2">
                            <label class="control-label">Amount<span class="text-danger">*</span></label>
                        	<input class="form-control" type="number" v-model="online_amount" placeholder="Enter online amount" min="0" step="0.01" />
                            <small v-if="job.cash_online && online_amount == job.cash_online" class="text-success">
                                <i class="bx bx-check-circle me-1"></i>Pre-filled from existing data
                            </small>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="payment_type == 2">
                            <label class="control-label">Payment ID<span class="text-danger">*</span></label>
                        	<input class="form-control" type="text" v-model="payment_id" placeholder="Enter payment ID" />
                            <small v-if="job.payment_id && payment_id == job.payment_id" class="text-success">
                                <i class="bx bx-check-circle me-1"></i>Pre-filled from existing data
                            </small>
                        </div>
                        
                        <!-- Both Payment Fields (Payment Type 3) -->
                        <div class="col-md-12 form-group mt-3" v-if="payment_type == 3">
                            <div class="alert alert-warning">
                                <i class="bx bx-info-circle me-2"></i>
                                <strong>Mixed Payment Details (Cash + Online)</strong>
                            </div>
                        </div>
                        
                        <div class="col-md-6 form-group mt-2" v-if="payment_type == 3">
                            <label class="control-label">Cash Amount<span class="text-danger">*</span></label>
                        	<input class="form-control" type="number" v-model="cash_amount" placeholder="Enter cash amount" min="0" step="0.01" />
                            <small v-if="job.cash_in_hand && cash_amount == job.cash_in_hand" class="text-success">
                                <i class="bx bx-check-circle me-1"></i>Pre-filled from existing data
                            </small>
                        </div>
                        
                        <div class="col-md-6 form-group mt-2" v-if="payment_type == 3">
                            <label class="control-label">Online Amount<span class="text-danger">*</span></label>
                        	<input class="form-control" type="number" v-model="online_amount" placeholder="Enter online amount" min="0" step="0.01" />
                            <small v-if="job.cash_online && online_amount == job.cash_online" class="text-success">
                                <i class="bx bx-check-circle me-1"></i>Pre-filled from existing data
                            </small>
                        </div>

                        <div class="col-md-12 form-group mt-2" v-if="payment_type == 3">
                            <label class="control-label">Payment ID<span class="text-danger">*</span></label>
                        	<input class="form-control" type="text" v-model="payment_id" placeholder="Enter payment ID" />
                            <small v-if="job.payment_id && payment_id == job.payment_id" class="text-success">
                                <i class="bx bx-check-circle me-1"></i>Pre-filled from existing data
                            </small>
                        </div>

                        <div class="col-md-12 form-group mt-3" v-if="payment_type == 3 && (cash_amount || online_amount)">
                            <div class="alert alert-success">
                                <strong>Total Amount: Rs. {{ (parseFloat(cash_amount || 0) + parseFloat(online_amount || 0)).toFixed(2) }}</strong>
                            </div>
                        </div>

                        <!-- Company Title -->
                        <div class="col-md-12 form-group mt-3">
                            <label class="control-label">Company Title<span class="text-danger">*</span></label>
                            <div class="dropdown">
                                <input 
                                    class="form-control dropdown-toggle" 
                                    type="text" 
                                    v-model="companyTitleSearch" 
                                    @input="filterCompanyTitles"
                                    @focus="showCompanyDropdown = true"
                                    @blur="hideDropdown"
                                    placeholder="Search and select company title" 
                                    autocomplete="off"
                                    required 
                                />
                                <div 
                                    class="dropdown-menu w-100" 
                                    :class="{ 'show': showCompanyDropdown && filteredCompanyTitles.length > 0 }"
                                    style="max-height: 200px; overflow-y: auto;"
                                >
                                    <div 
                                        v-for="company in filteredCompanyTitles" 
                                        :key="company.id"
                                        class="dropdown-item" 
                                        @click="selectCompanyTitle(company)"
                                        style="cursor: pointer;"
                                    >
                                        {{ company.title }}
                                    </div>
                                    <div v-if="filteredCompanyTitles.length === 0 && companyTitleSearch" class="dropdown-item text-muted">
                                        No company titles found
                                    </div>
                                </div>
                            </div>
                            <small v-if="selectedCompanyTitle" class="text-success">
                                <i class="bx bx-check-circle me-1"></i>Selected: {{ selectedCompanyTitle.title }}
                            </small>
                        </div>
                        </template>
                    </div>
					
					<div class="col-md-12 form-group mt-3">
						<button v-if="!isDealerRole" type="submit" class="btn btn-primary me-3">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

        <!-- Completion Modal -->
        <CompletionModal 
            ref="completionModalRef" 
            :job="job" 
            :job_id="job_id"
            @completed="handleJobDataCompletion" 
        />

    </div>	
</template>

<script setup>
import { onMounted, ref, computed, getCurrentInstance, inject } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { Modal } from "bootstrap";
import DynamicModal from '@/components/dynamic_modal.vue';
import CompletionModal from '@/components/completion_modal.vue';
import { get, post } from '@/utils/api';
import { routes } from '@/constants/routes';
import Swal from '@/utils/swal';
import { goBack } from '@/utils/urlHider';
import {
	DEALER_ROLE_ID,
	readStoredLoginDetails,
	parseSettingsDealerProfile,
} from '@/utils/dealerRole3Profile';

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();
const imageUrl = inject('imageUrl');

// Custom back navigation function
const handleGoBack = () => {
  const success = goBack(router);
  if (!success) {
    // If no history, go to dashboard as fallback
    router.push({ name: 'defaultRoot' });
  }
};

const job_id = route.query.id;
const job = ref({});
const modal_title = "Update Work Status";
const button_title = "Update";
const errors = ref({});
const payment_type = ref("");
const total_amount = ref("");
const online_amount = ref("");
const cash_amount = ref("");
const payment_id = ref("");
const user_role_id = ref(null);

const isDealerRole = computed(() => Number(user_role_id.value) === DEALER_ROLE_ID);

const showWorkCompletedPaidAlert = computed(
	() => job.value.job_status == 3 && job.value.payment_status == 1,
);

/** Hide Mark As Completed for dealers when job is done but payment is not received. */
const showMarkAsCompletedLink = computed(() => {
	if (showWorkCompletedPaidAlert.value) return false;
	if (isDealerRole.value && job.value.job_status == 3) return false;
	return !(job.value.payment_status == 1 && job.value.job_status == 3);
});

// Company title variables
const companyTitles = ref([]);
const filteredCompanyTitles = ref([]);
const companyTitleSearch = ref('');
const selectedCompanyTitle = ref(null);
const showCompanyDropdown = ref(false);

let dynamicmodal = null;
const completionModalRef = ref(null);

const showModal = () => {
    if (dynamicmodal) dynamicmodal.show();
};

const hideModal = () => {
    if (dynamicmodal) dynamicmodal.hide();
};

const closeModal = () => {
    hideModal();
    resetForm();
};

const updateStatus = () => {
    errors.value = {};
    resetForm();
    // Auto-fill total amount with job's total amount
    total_amount.value = job.value.total_amount || "";
    
    // Pre-fill payment type and related fields if job already has payment info
    if (job.value.payment_type) {
        payment_type.value = job.value.payment_type;
        onPaymentTypeChange();
    }
    
    // Pre-select company title if job has company_title_id
    if (job.value.company_title_id && companyTitles.value.length > 0) {
        const existingCompany = companyTitles.value.find(company => company.id === job.value.company_title_id);
        if (existingCompany) {
            selectedCompanyTitle.value = existingCompany;
            companyTitleSearch.value = existingCompany.title;
        }
    }
    
    showModal();
};

const onPaymentTypeChange = () => {
    if (payment_type.value == 1) {
        // Cash payment - pre-fill cash amount with total amount or existing cash amount
        if (job.value.cash_in_hand) {
            cash_amount.value = job.value.cash_in_hand;
        } else {
            cash_amount.value = total_amount.value;
        }
    } else if (payment_type.value == 2) {
        // Online payment - pre-fill online amount and payment ID if available
        if (job.value.cash_online) {
            online_amount.value = job.value.cash_online;
        }
        if (job.value.payment_id) {
            payment_id.value = job.value.payment_id;
        }
    } else if (payment_type.value == 3) {
        // Both payment - pre-fill both amounts and payment ID if available
        if (job.value.cash_in_hand) {
            cash_amount.value = job.value.cash_in_hand;
        }
        if (job.value.cash_online) {
            online_amount.value = job.value.cash_online;
        }
        if (job.value.payment_id) {
            payment_id.value = job.value.payment_id;
        }
    }
};

const resetForm = () => {
    payment_type.value = "";
    total_amount.value = "";
    online_amount.value = "";
    cash_amount.value = "";
    payment_id.value = "";
    
    // Reset company title fields
    companyTitleSearch.value = '';
    selectedCompanyTitle.value = null;
    showCompanyDropdown.value = false;
};

// Fetch company titles
const fetchCompanyTitles = () => {
    get(routes.getSpdCompanyTitles, {}, false)
        .then((response) => {
            if (response.status === 200) {
                console.log('Company titles:', response.data.data);
                companyTitles.value = response.data.data;
                filteredCompanyTitles.value = response.data.data;
                
                // Pre-select company title if job has company_title_id and no selection yet
                if (job.value.company_title_id && !selectedCompanyTitle.value) {
                    const existingCompany = companyTitles.value.find(company => company.id === job.value.company_title_id);
                    if (existingCompany) {
                        selectedCompanyTitle.value = existingCompany;
                        companyTitleSearch.value = existingCompany.title;
                    }
                }
            } else {
                Swal.fire('Error', response.data.message || 'Error fetching company titles', 'error');
            }
        })
        .catch((error) => {
            if (error.response?.status === 422) {
                Swal.fire('Validation Error', 'Please check your input data', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
                router.push({ name: 'login' });
            } else {
                Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
            }
        });
};

// Filter company titles based on search
const filterCompanyTitles = () => {
    if (!companyTitleSearch.value.trim()) {
        filteredCompanyTitles.value = companyTitles.value;
    } else {
        filteredCompanyTitles.value = companyTitles.value.filter(company =>
            company.title.toLowerCase().includes(companyTitleSearch.value.toLowerCase())
        );
    }
};

// Select company title
const selectCompanyTitle = (company) => {
    selectedCompanyTitle.value = company;
    companyTitleSearch.value = company.title;
    showCompanyDropdown.value = false;
};

// Hide dropdown with delay to allow click events
const hideDropdown = () => {
    setTimeout(() => {
        showCompanyDropdown.value = false;
    }, 200);
};

const submitPayment = () => {
    if (isDealerRole.value) return;

    if (!payment_type.value) {
        Swal.fire('Error', 'Please select a payment type.', 'error');
        return;
    }

    if (!selectedCompanyTitle.value) {
        Swal.fire('Error', 'Please select a company title.', 'error');
        return;
    }

    if (!total_amount.value || parseFloat(total_amount.value) <= 0) {
        Swal.fire('Error', 'Please enter a valid total amount.', 'error');
        return;
    }

    // Validate based on payment type
    if (payment_type.value == 1) {
        // Cash payment - validate received amount matches total amount
        if (!cash_amount.value || parseFloat(cash_amount.value) <= 0) {
            Swal.fire('Error', 'Please enter a valid received amount for cash payment.', 'error');
            return;
        }
        
        // Check if received amount matches total amount
        if (Math.abs(parseFloat(cash_amount.value) - parseFloat(total_amount.value)) > 0.01) {
            Swal.fire('Error', 'Received amount must equal total amount for cash payment.', 'error');
            return;
        }
    } else if (payment_type.value == 2) {
        if (!online_amount.value || !payment_id.value) {
            Swal.fire('Error', 'Please fill in all required fields for online payment.', 'error');
            return;
        }
        if (parseFloat(online_amount.value) <= 0) {
            Swal.fire('Error', 'Online amount must be greater than 0.', 'error');
            return;
        }
        
        // Validate that online amount equals total amount
        // if (Math.abs(parseFloat(online_amount.value) - parseFloat(total_amount.value)) > 0.01) {
        //     Swal.fire('Error', `Online amount (${online_amount.value}) must equal total amount (${total_amount.value}).`, 'error');
        //     return;
        // }
    } else if (payment_type.value == 3) {
        if (!cash_amount.value || !online_amount.value || !payment_id.value) {
            Swal.fire('Error', 'Please fill in all required fields for both payment types.', 'error');
            return;
        }
        if (parseFloat(cash_amount.value) <= 0 || parseFloat(online_amount.value) <= 0) {
            Swal.fire('Error', 'Both cash and online amounts must be greater than 0.', 'error');
            return;
        }
        
        // Validate that cash + online = total amount
        // const sum = parseFloat(cash_amount.value) + parseFloat(online_amount.value);
        // if (Math.abs(sum - parseFloat(total_amount.value)) > 0.01) {
        //     Swal.fire('Error', `Sum of cash (${cash_amount.value}) and online (${online_amount.value}) amounts (${sum}) must equal total amount (${total_amount.value}).`, 'error');
        //     return;
        // }
    }

    const payload = {
        job_id: job_id,
        payment_type: payment_type.value,
        total_amount: total_amount.value,
        payment_id: payment_id.value,
        online_amount: online_amount.value || 0,
        cash_amount: cash_amount.value || 0,
        company_title_id: selectedCompanyTitle.value.id,
    };

    
    get(routes.UpdatePayment, { params: payload }, false)
        .then((response) => {
            if(response.status === 200){
                Swal.fire('Success', response.data.message || 'Payment updated successfully', 'success');
                fetchJob(); // Refresh job details
                closeModal();
                resetForm();
            } else {
                Swal.fire('', response.data.message || 'Failed to update payment', 'error');
            }
        })
        .catch((error) => {
            if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.job_id?.[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
            }
        });
};

const fetchJob = () => {

    const params = {
        job_id: job_id
    }

    get(routes.JobDetail, { params }, false)
        .then((response) => {
            if(response.status === 200){
                console.log(response.data.data);
				job.value = response.data.data.details;
			} else {
				Swal.fire('', response.data.message || 'Failed to fetch job', 'error');
			}
        })
        .catch((error)  => {
            if (error.response?.status === 422) {
				Swal.fire('', error.response.data.message.job_id?.[0] || 'Validation error', 'error');
			} else if (error.response?.status === 500) {
				Swal.fire('', error.response.statusText || 'Server error', 'error');
			} else if (error.response?.status === 401) {
				Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
				router.push({ name: 'login' });
			} else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
            }
        });
};

// Show completion modal
const showCompletionModal = () => {
    if (completionModalRef.value) {
        completionModalRef.value.showModal();
    }
};

// Handle job completion
const handleJobDataCompletion = async (formData) => {
    try {
        // Make API call to mark the job as completed
        const response = await post(routes.completeJobData, formData);
        
        if (response.status === 200) {
            Swal.fire('Success', response.data.message || 'Job marked as completed successfully!', 'success');
            fetchJob(); // Refresh job details
            // Clear form after successful completion
            if (completionModalRef.value) {
                completionModalRef.value.clearForm();
            }
        } else {
            Swal.fire('Error', response.data.message || 'Failed to mark job as completed', 'error');
        }
    } catch (error) {
        console.error('Error completing job:', error);
        
        if (error.response?.status === 422) {
            // Validation errors
            const errors = error.response.data.message;
            let errorMessage = 'Validation failed:\n';
            
            // Format validation errors
            Object.keys(errors).forEach(key => {
                if (Array.isArray(errors[key])) {
                    errorMessage += `${key}: ${errors[key].join(', ')}\n`;
                } else {
                    errorMessage += `${key}: ${errors[key]}\n`;
                }
            });
            
            Swal.fire('Validation Error', errorMessage, 'error');
        } else if (error.response?.status === 404) {
            Swal.fire('Error', 'Job not found', 'error');
        } else if (error.response?.status === 500) {
            Swal.fire('Error', 'Server error occurred', 'error');
        } else if (error.response?.status === 401) {
            Swal.fire('Error', 'Unauthorized access', 'error');
            router.push({ name: 'login' });
        } else {
            Swal.fire('Error', error.response?.data?.message || 'Failed to mark job as completed. Please try again.', 'error');
        }
    }
};

onMounted(() => {
    const ls = readStoredLoginDetails();
    if (ls) {
        const p = parseSettingsDealerProfile(ls);
        if (p.roleId != null) user_role_id.value = p.roleId;
    }
    dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
    fetchJob();
    fetchCompanyTitles();
});
</script>
